import api from '../api/axios';

export interface SalesOrderItem {
  id?: number;
  salesOrder?: number;
  product: number;
  description?: string;
  quantity: number;
  unitPrice: number;
  discount?: number;
  tax?: number;
  total: number;
}

export interface SalesOrder {
  id?: number;
  orderNumber: string;
  customer: number;
  quotation?: number;
  orderDate: string;
  deliveryDate?: string;
  subtotal: number;
  tax: number;
  discount: number;
  total: number;
  status?: 'pending' | 'confirmed' | 'processing' | 'shipped' | 'delivered' | 'cancelled';
  notes?: string;
  createdBy?: number;
}

const SalesOrderService = {
  getAll: (params?: any) => api.get('/sales-orders', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/sales-orders/${id}`, { 
      params: params || { populate: ['customer', 'quotation', 'createdBy'] } 
    }),
  create: (data: SalesOrder) => api.post('/sales-orders', { data }),
  update: (id: number, data: Partial<SalesOrder>) => 
    api.put(`/sales-orders/${id}`, { data }),
  delete: (id: number) => api.delete(`/sales-orders/${id}`),
  
  // Sales Order Items
  getItems: (salesOrderId: number) =>
    api.get('/sales-order-items', {
      params: {
        'filters[salesOrder][id][$eq]': salesOrderId,
        populate: 'product',
      },
    }),
  createItem: (data: SalesOrderItem) => api.post('/sales-order-items', { data }),
  updateItem: (id: number, data: Partial<SalesOrderItem>) =>
    api.put(`/sales-order-items/${id}`, { data }),
  deleteItem: (id: number) => api.delete(`/sales-order-items/${id}`),
};

export default SalesOrderService;

